import { jsxs as o, Fragment as S, jsx as t } from "react/jsx-runtime";
import { DealActionBarContainer as b, DealActionBarItem as c, DealActionBarCaption as i, DealActionBarVoteButton as f, DealActionBarItemSaved as k } from "./style.js";
import { DealActionBarIcon as O, SkeletonCommentLink as _, SkeletonLink as q, SkeletonSaveButton as w, SkeletonSaveButtonMobile as z, SkeletonVoteButton as G, dealActionItemStyle as H } from "./style.js";
import { DealAction as C } from "../../../types/Deal/index.js";
import { DealSaveButton as h } from "../DealSaveButton/DealSaveButton.js";
import { getSavedButtonLabelTranslationKey as s } from "../DealSaveButton/consts.js";
import { useTranslation as v } from "../../../hooks/useTranslation/index.js";
import { DealActionBarCommentLink as I } from "../Card/components/DealActionBarCommentLink/index.js";
import { DealActionBarBottomMobile as L } from "./DealActionBarBottomMobile/index.js";
function E({
  className: B,
  temperature: d,
  voteInfo: p,
  inactive: a,
  commentUrl: u,
  commentCount: A,
  isSaved: l,
  hasSaveButton: m,
  iconColor: D,
  dispatch: e,
  id: n
}) {
  const { t: r } = v("common");
  return /* @__PURE__ */ o(S, { children: [
    /* @__PURE__ */ o(b, { "aria-disabled": a, className: B, children: [
      /* @__PURE__ */ o(c, { children: [
        /* @__PURE__ */ t(
          I,
          {
            commentUrl: u,
            commentCount: A,
            inactive: a,
            dispatch: () => e({ type: C.CLICK_COMMENTS, payload: { id: n } }),
            title: r("deal-action-bar-comment-button-title")
          }
        ),
        /* @__PURE__ */ t(i, { children: r("deal-action-bar-comment-button-title") })
      ] }),
      /* @__PURE__ */ o(c, { children: [
        /* @__PURE__ */ t(
          f,
          {
            id: n,
            inactive: a,
            temperature: d,
            voteInfo: p,
            dispatch: e
          }
        ),
        /* @__PURE__ */ t(i, { children: r("deal-action-bar-vote-button-title") })
      ] }),
      m && /* @__PURE__ */ o(k, { children: [
        /* @__PURE__ */ t(
          h,
          {
            isSaved: l || void 0,
            dispatch: e,
            iconColor: D,
            id: n
          }
        ),
        /* @__PURE__ */ t(i, { children: r(s(l)) })
      ] })
    ] }),
    /* @__PURE__ */ t(
      L,
      {
        isSaved: l || void 0,
        dispatch: e,
        id: n,
        hasSaveButton: m
      }
    )
  ] });
}
export {
  E as DealActionBar,
  i as DealActionBarCaption,
  b as DealActionBarContainer,
  O as DealActionBarIcon,
  c as DealActionBarItem,
  k as DealActionBarItemSaved,
  f as DealActionBarVoteButton,
  _ as SkeletonCommentLink,
  q as SkeletonLink,
  w as SkeletonSaveButton,
  z as SkeletonSaveButtonMobile,
  G as SkeletonVoteButton,
  H as dealActionItemStyle
};
